import { render, staticRenderFns } from "./NewBuild.vue?vue&type=template&id=05adf9e8&scoped=true&"
import script from "./NewBuild.vue?vue&type=script&lang=js&"
export * from "./NewBuild.vue?vue&type=script&lang=js&"
import style0 from "./NewBuild.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewBuild.vue?vue&type=style&index=1&id=05adf9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05adf9e8",
  null
  
)

export default component.exports